module.exports = __webpack_public_path__ + "media/images/daodi-logo-747ab7d925725957d852cabc38fa1378.png";